// @flow
import * as React from "react";

import { buttonStyles } from "../../global/components/StyledButtons";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";

type PhotoCheckStatesType = {
  open: boolean,
  result: { [key: string]: string }
};

type PhotoCheckPropsType = {
  onRef: Function,
  resetForm: Function,
  addEnrolment: Function,
  classes: { [key: string]: string }
};

class PhotoCheck extends React.Component<PhotoCheckPropsType, PhotoCheckStatesType> {
  constructor(props: PhotoCheckPropsType) {
    super(props);
    this.state = {
      open: false,
      result: {}
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleClickOpen = (data: { [key: string]: string }) => {
    this.setState({ open: true, result: data });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.resetForm();
  };

  addEnrolment = (): * => {
    this.props.addEnrolment(this.state.result);
    this.props.resetForm();
  }

  render(): * {
    const classes = this.props.classes;
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title">
          <WarningIcon color="secondary" className="right-margin-10" style={{ verticalAlign: "middle" }} />Check your Photo
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ fontWeight: "500", fontSize: "18px" }}>
            This photo looks different with the others you uploaded, are you sure you still want to continue uploading?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" className={classes.linkBtn} onClick={this.handleClose}>
            Cancel
          </Button>
          <Button type="button" variant="raised" onClick={this.addEnrolment} color="secondary" id="submitBtn" className="dark-btn">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
}

export default withStyles(buttonStyles)(PhotoCheck);


// WEBPACK FOOTER //
// ./src/conference/component/PhotoCheck.js